export const LAST_EMAIL = 'LAST_EMAIL';
